import { styled } from '@mui/system';
import { Box, IconButton } from '@mui/material';

const Card = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.white,
  padding: '0 15px',
  borderRadius: '8px',
  height: '60px',
  boxShadow: '0 0 9px rgba(0, 0, 0, 0.04)',
}));

export const CardContainer = styled(Card)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '10px',
  textDecoration: 'none',
});

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '24px',
  height: '24px',
  color: theme.palette.primary.gray50,
  padding: 0,
}));

export const Icon = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '18px',
  height: '18px',
  color: theme.palette.primary.gray50,
  padding: 0,
}));
